module.exports = __webpack_public_path__ + "static/media/GH.e274c912.png";